import { Image, Text } from 'components/common'

import EmptyStyle from './style'

const Empty = ({ className = '' }) => {
    return (
        <EmptyStyle className={className}>
            <Image className='not-found' src='/images/notFound.gif' />
            <Text tag={'h3'} className='not-found-text PopReg h4' text='Sorry, but there is no debate over here' />
        </EmptyStyle>
    )
}


export default Empty